function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { patchDocument, PatchType, TextRun } from 'docx';
import * as QueryString from 'query-string';
import ProjectQuestionnaireTemplateService from '../project_questionnaire_template.service';
import convertHTMLToPlainText from '@rd-web-markets/shared/dist/util/helpers/convertHTMLToPlainText';
const getDocumentName = (projectData, questionnaire_type) => {
  switch (questionnaire_type) {
    case 'new_it_project_document':
      return 'New IT Project Questionnaire.docx';
    case 'new_non_it_project_document':
      return 'New Non-IT Project Questionnaire.docx';
    case 'ongoing_it_project_document':
      return "Ongoing IT ".concat(projectData.claimGroupYear, "-Project-").concat(projectData.project_name, " Questionnaire.docx");
    case 'ongoing_non_it_project_document':
      return "Ongoing Non-IT ".concat(projectData.claimGroupYear, "-Project-").concat(projectData.project_name, " Questionnaire.docx");
    default:
      return 'Project Questionnaire.docx';
  }
};
const ONGOING_QUESTIONNAIRE_TYPES = ['ongoing_non_it_project_document', 'ongoing_it_project_document'];
const getPatcherObject = projectDataField => {
  let text = projectDataField || '';
  return {
    type: PatchType.PARAGRAPH,
    children: [new TextRun(text)]
  };
};
const getNewDocumentPatches = projectData => {
  const leadConsultant = projectData.consultant_roles.find(role => role.role === 'claim_group_access_lead_consultant');
  const companyName = projectData.company.abbreviated_name;
  return {
    lead_consultant: getPatcherObject(leadConsultant.user ? leadConsultant.user.name : ''),
    company_name: getPatcherObject(companyName)
  };
};

/**
 * Returns a new TextRun that has children TextRuns that each except the first have a line break before them if they contain text.
 * 
 * @returns 
 */
const getPatcherObjectFromQuestionnaireFields = (projectData, fieldNames) => {
  projectData || (projectData = {});
  const fullText = fieldNames.map(fieldName => projectData[fieldName] || '').join('');
  if (!fullText.trim().length) {
    return {
      type: PatchType.PARAGRAPH,
      children: [new TextRun({
        text: 'No update.'
      })]
    };
  }
  const textRuns = fieldNames.map((fieldName, index) => {
    const text = convertHTMLToPlainText(projectData[fieldName]) || '';
    let lineBreaksBeforeCount = 1;

    // break adds a new line BEFORE the text run. No need for a new line if there is no text in this project field, or if it is the FIRST Text Run, because there is already an existing line break.
    if (index === 0 || !text.length) {
      lineBreaksBeforeCount = 0;
    }
    return new TextRun({
      text,
      break: lineBreaksBeforeCount
    });
  });
  return {
    type: PatchType.PARAGRAPH,
    children: textRuns
  };
};
const getOngoingDocumentPatches = (projectData, questionnaire_type) => {
  const commonPatches = {
    company_consultant: getPatcherObject(projectData.company_consultant_text),
    client_text_field: getPatcherObject(projectData.client_text),
    project_title: getPatcherObject(projectData.project_name),
    project_code: getPatcherObject(projectData.internal_project_number),
    project_manager: getPatcherObject(projectData.manager_name),
    project_start_date: getPatcherObject(projectData.start_date),
    project_end_date: getPatcherObject(projectData.end_date),
    partnership: getPatcherObject(projectData.partnership_contact_details),
    previous_year_project_type: getPatcherObject(projectData.previous_year_project_type === 'new_project' ? 'New Project' : 'Update'),
    previous_year: getPatcherObject(convertHTMLToPlainText(projectData.previous_claim_group_year))
  };
  if (questionnaire_type === 'ongoing_it_project_document') {
    var _projectData$previous;
    return _objectSpread(_objectSpread({}, commonPatches), {}, {
      // Its either an ongoing questionnaire in which case it we need 1 field or a new questionnaire in which case we need 3 fields.
      // If we have the field it_context_changes - the prior year was a new project.
      it_context_objectives: (_projectData$previous = projectData.previous_questionnaire) !== null && _projectData$previous !== void 0 && _projectData$previous.it_context_changes ? getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['it_context_objectives', 'it_context_changes']) : getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['it_context_objectives']),
      it_technical_aspects_project_phases: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['it_technical_aspects_project_phases']),
      it_technical_aspects_major_workers_faced: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['it_technical_aspects_major_workers_faced']),
      it_technical_aspects_any_form_of_development: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['it_technical_aspects_any_form_of_development']),
      it_results_resulted_in_commercialization: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['it_results_resulted_in_commercialization'])
    });
  } else {
    var _projectData$previous2, _projectData$previous3;
    const nonItReportingTypesField = (_projectData$previous2 = projectData.previous_questionnaire) !== null && _projectData$previous2 !== void 0 && _projectData$previous2.non_it_reporting_types ? ['non_it_reporting_types'] : ['non_it_technical_aspects_types_of_rnd_activities'];
    return _objectSpread(_objectSpread({}, commonPatches), {}, {
      // its either an ongoing questionnaire in which case it we need 1 field or a new questionnaire in which case we need 3 fields.
      context_of_project_historical_information: (_projectData$previous3 = projectData.previous_questionnaire) !== null && _projectData$previous3 !== void 0 && _projectData$previous3.non_it_context_phases_of_project ? getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_context_phases_of_project']) : getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_context_in_company', 'non_it_context_scientific_advances', 'non_it_context_phases']),
      non_it_reporting_types: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, [nonItReportingTypesField]),
      non_it_context_in_company: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_context_in_company']),
      non_it_context_scientific_advances: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_context_scientific_advances']),
      non_it_context_phases: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_context_phases']),
      non_it_technical_aspects_types_of_rnd_activities: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_technical_aspects_types_of_rnd_activities']),
      non_it_technical_aspects_major_technical_uncertanties: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_technical_aspects_major_technical_uncertanties']),
      non_it_results_lead_to_marketing_of_product: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_results_lead_to_marketing_of_product']),
      non_it_results_knowledge: getPatcherObjectFromQuestionnaireFields(projectData.previous_questionnaire, ['non_it_results_knowledge'])
    });
  }
};
export const generateProjectQuestionnaire = async (projectData, questionnaire_type) => {
  const {
    download
  } = ProjectQuestionnaireTemplateService;
  download(QueryString.stringify({
    questionnaire_type
  })).then(blob => {
    const reader = new FileReader();
    reader.onload = function (event) {
      const arrayBufferData = event.target.result;
      patchDocument(arrayBufferData, {
        outputType: "nodebuffer",
        patches: ONGOING_QUESTIONNAIRE_TYPES.includes(questionnaire_type) ? getOngoingDocumentPatches(projectData, questionnaire_type) : getNewDocumentPatches(projectData)
      }).then(finaldata => {
        const blob = new Blob([finaldata], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
        // download the file
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = getDocumentName(projectData, questionnaire_type);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });
    };
    reader.readAsArrayBuffer(blob);
  }).catch(error => {
    console.error('Error fetching template.docx:', error);
  });
};